import React from "react";
import { Link } from "react-router-dom";
import { DataTable } from "../../../../../components";
import {
  LinearProgress,
  Box,
  linearProgressClasses,
  styled,
} from "@mui/material";
import BreadCrumb from "../../../../../components/navbar/Breadcrumb";
import FiltrosProveedores from "../../../../../components/filtros/filtrosProveedores";

const BorderLinearProgress = styled(LinearProgress)((props) => ({
  height: 15,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: "#eee",
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: props.value,
    backgroundColor:
      props.value < 25 ? "#FF5252" : props.value < 75 ? "#fcba03" : "#7bc977",
  },
}));

function LinearProgressWithLabel(props) {
  return (
    <Box display="flex" alignItems="center">
      <Box width="100%" mr={2}>
        <BorderLinearProgress {...props} variant="determinate" />
      </Box>
      <Box minWidth={35}>
        {`${Math.round(props.value * 100) / 100}%`}
      </Box>
    </Box>
  );
}

function ProveedoresOriginal({
  t,
  data,
  loading,
  fetchData,
  busqueda,
  filtrarDatos,
  clearFilters,
  busquedaActiva,
  setBusquedaActiva,
  clearFilterActivo,
  setClearFilterActivo,
}) {
  const proveedoresRows = [
    {
      id: "razonSocial",
      numeric: false,
      disablePadding: false,
      label: t('columns.supplier'),
      overrideFunc: (data, row) => (
        <Link to={"/proveedores/" + row.nif}>{data}</Link>
      ),
    },
    {
      id: "municipio",
      numeric: false,
      disablePadding: false,
      label: t('columns.municipality'),
    },
    {
      id: "provincia",
      numeric: false,
      disablePadding: false,
      label: t('columns.province'),
    },
    {
      id: "cumplimiento",
      numeric: false,
      disablePadding: false,
      label: t('columns.compliance'),
      noObjeto: true,
      overrideFunc: (data) => (
        <LinearProgressWithLabel value={data} variant="determinate" />
      ),
    },
  ];

  return (
    <>
      <BreadCrumb rutas={[{ path: `/proveedores`, label: t('title') }]} />
      <div className="listPage">
        <div className="gridCard">
          <div className="gridHead">{t('listHeader')}</div>
          <div className="tableContainer">
            <div>
              <FiltrosProveedores onFilter={filtrarDatos} clearFilter={clearFilters} filtrosIniciales={busqueda} />
              <div className="exportar"></div>
            </div>
            <div className="tableWrapper">
              <Box className="pageContent">
                <Box sx={{ mb: 10 }}>
                  <DataTable
                    data={data.rows}
                    isLoading={loading}
                    headers={proveedoresRows}
                    fetcher={fetchData}
                    currentPage={data.current_page}
                    meta={data.meta}
                    totalItems={data.total}
                    totalPages={data.totalPages}
                    nextPage={data.next_page}
                    filtros={busqueda}
                    busquedaActiva={busquedaActiva}
                    setBusquedaActiva={setBusquedaActiva}
                    clearFilterActivo={clearFilterActivo}
                    setClearFilterActivo={setClearFilterActivo}
                    mensaje={t('noSuppliers')}
                  />
                </Box>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProveedoresOriginal;
